import { render, staticRenderFns } from "./PackingListTable.vue?vue&type=template&id=5ac9273a&scoped=true&"
import script from "./PackingListTable.vue?vue&type=script&lang=js&"
export * from "./PackingListTable.vue?vue&type=script&lang=js&"
import style0 from "./PackingListTable.vue?vue&type=style&index=0&id=5ac9273a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac9273a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/driehle1/rezeptdatenbank/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac9273a')) {
      api.createRecord('5ac9273a', component.options)
    } else {
      api.reload('5ac9273a', component.options)
    }
    module.hot.accept("./PackingListTable.vue?vue&type=template&id=5ac9273a&scoped=true&", function () {
      api.rerender('5ac9273a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/trip-packing-list/PackingListTable.vue"
export default component.exports